import { render, staticRenderFns } from "./ChatOrderModalAddProduct.vue?vue&type=template&id=aaa38f4e&scoped=true&"
import script from "./ChatOrderModalAddProduct.vue?vue&type=script&lang=js&"
export * from "./ChatOrderModalAddProduct.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderModalAddProduct.vue?vue&type=style&index=0&id=aaa38f4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa38f4e",
  null
  
)

export default component.exports